import {useContext, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useMsal } from '@azure/msal-react'
import {unfolder, validContext} from '../lib'
import logo from '../logos/ai-nesting-studio.svg';
import icon_home from '../images/home.svg'
import icon_manual from '../images/manual.svg'
import icon_view_report from '../images/view_report.svg'
import icon_view_voice from '../images/voice-icon.svg'
import icon_costcenter from '../images/costcenter-icon.svg'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import '../styles/titleBar.scss'

export default function TitleBar() {
  const [isValid, setIsValid] = useContext(validContext)
  const navigate = useNavigate()
  const { instance } = useMsal()
  const { name, last_name } = JSON.parse(localStorage.getItem('infoUser')) || {
    id: undefined,
  }
  const user = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey');
  const logout = e => {
    localStorage.clear()
    sessionStorage.clear()
    setIsValid(false)
    instance.logoutPopup().catch(error => console.log(error))
    
  }
  function delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
  useEffect(function () {
      // console.log("unfolder(localStorage.getItem('hashInfo'), 'IANestingKey')", unfolder(localStorage.getItem('hashInfo'), 'IANestingKey'))
  }, [])

  return (
    <header style={{
        boxShadow: '0px 3px 6px #00000029',
    }}>
      <Link to={'/'}>
          <img id='home1-tp'  className="logo" src={logo} alt=""/>
          <Tooltip anchorId="home1-tp" content={`Go to home`} place="top" />
      </Link>
      <div className="header-options">
          <div className="d-flex flex-row align-items-center">
              <Link id='home-tp' to={`/`} style={{marginRight: 15}}>
                  <div><img src={icon_home} style={{width: 30}} alt="Bell Icon" /></div>
              </Link>
              <Tooltip style={{fontSize: 13, maxWidth: 160}}
                  anchorId="home-tp" content={`Go to home`} place="top" />
              <a download href='/icons/MANUALNESTING.pdf'  id='guide-tp' to={`.`} style={{marginRight: 15}}>
                  <div><img src={icon_manual} style={{width: 30}} alt="Gear Icon" /></div>
              </a>
              <Tooltip anchorId="voice-tp" content={`Voices Customizable`} place="top"
                style={{fontSize: 13, maxWidth: 160}} />
              <Link id='voice-tp' to={`/Voices`} style={{marginRight: 15}}>
                  <div><img src={icon_view_voice} style={{width: 30}} alt="Voice Icon" /></div>
              </Link>
              <Tooltip anchorId="cost_center" content={`Cost Center`} place="top" style={{fontSize: 13, maxWidth: 160}} />
              <Link id='cost_center' to={`/cost_center`} style={{marginRight: 15}}>
                  <div><img src={icon_costcenter} style={{width: 33}} alt="Cost Center" /></div>
              </Link>
              <Tooltip style={{fontSize: 13}} anchorId="guide-tp" content={`Consult AI Nesting guide`} place="top" />
              <Link id='report-tp' to={`/project-reports`} style={{marginRight: 15}}>
                  <div><img src={icon_view_report} style={{width: 30}} alt="Report Icon" /></div>
              </Link>
              <Tooltip style={{fontSize: 13, maxWidth: 160}} anchorId="report-tp" content={`Reports`} place="top" />
               <div onClick={()=>{logout()}} id='logout-tp' to={`/project-reports`} style={{marginRight: 15, cursor: "pointer"}}>
                  <div><img src='/icons/logout-icon.svg' style={{width: 30}} alt="Gear Icon" /></div>
               </div>
               <Tooltip anchorId="logout-tp" content={`Log Out`} place="top" />
          </div>
          <div className="d-flex flex-column" style={{marginLeft: 5}}>
            <div style={{fontWeight: 'bold', fontSize: 16, color: '#707070', whiteSpace: 'nowrap', fontFamily: 'principal-font'}}>
                {user.name + ' ' + user.last_name}
            </div>
            <div style={{fontSize: 15, marginTop: -5, color: '#707070', fontFamily: 'principal-font-light'}}>
                {user.role === 1 ? 'Admin' : ''}
                {user.role === 2 ? 'Manager' : ''}
                {user.role === 3 ? 'Editor' : ''}
                {user.role === 4 ? 'Reader' : ''}
            </div>
          </div>

          {/*<div className="userIcon"></div>*/}
          {/*<div className="userInfo">*/}
          {/*    <p className="name">{name}</p>*/}
          {/*    <p className="title">{last_name}</p>*/}
          {/*</div>*/}
          {/*<div className="logout ml-3" onClick={logout}>*/}
          {/*    <img src="/icons/logout.png" alt="Logout" />*/}
          {/*</div>*/}
      </div>
    </header>
  )
}
